import { createReducer } from '@reduxjs/toolkit'
import { get, isUndefined } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export default createReducer(
  {},
  {
    [types.UPDATE_SAVED_SEARCH]: (state, action) => action.payload,
  },
)

export const selectSavedSearch = (store) => {
  const persistedSearch = get(store, 'savedSearch.query')
  if (!isUndefined(persistedSearch)) {
    return persistedSearch
  }
  return get(store, 'user.record.SavedSearch.FacetValues')
}

export const selectSavedNameSearch = (store) => {
  const persistedNameSearch = get(store, 'savedSearch.nameSearch')
  if (!isUndefined(persistedNameSearch)) {
    return persistedNameSearch
  }
  return get(store, 'user.record.SavedSearch.Name')
}
